import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_close",
  "use": "svg_close-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"svg_close\"><path fill-rule=\"evenodd\" fill=\"currentColor\" d=\"m9.207 8 7.071 7.071a.499.499 0 0 1 0 .707.499.499 0 0 1-.707 0L8.5 8.707l-7.071 7.071a.499.499 0 0 1-.707 0 .499.499 0 0 1 0-.707L7.793 8 .722.929a.5.5 0 0 1 .707-.707L8.5 7.293 15.571.222a.5.5 0 0 1 .707.707L9.207 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol